import React from "react";

export default function LiveBadge({ className = "" }) {
  return (
    <span
      data-testid="live-badge"
      className={`inline-flex items-center gap-1.5 bg-tv-live text-white text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-white tv-pulse" />
      Live
    </span>
  );
}
